import "../sass/cart.scss";
import { $Q, $Qll, dataToggle } from "graditify-utils";

$Qll(".accordion").forEach((item) => {
  $Q(".accordion-title", item).addEventListener("click", (e) => {
    e.preventDefault();
    dataToggle(item);
  });
});

$Qll(".input-field").forEach((item) => {
  $Qll(".change-input", item).forEach((button) => {
    button.addEventListener("click", (e) => {
      const input = $Q(".qtyInput", item);

      switch (button.dataset.type) {
        case "minus":
          input.value = Number(input.value) - 1;
          break;
        case "plus":
          input.value = Number(input.value) + 1;
          break;
      }

      input.dispatchEvent(new Event("change"));
    });
  });
});
